module.exports = __webpack_public_path__ + "static/media/service-card-preview.67aa9ce6.jpg";